<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="mb10">
      <div class="mb15">
        <span class='mr15' @click='createSon'>
          <a-button type="primary">
            添加子菜单
          </a-button>
        </span>
        <span class='mr15' @click='createTop'>
          <a-button>
            <PlusOutlined /> 添加顶级菜单
          </a-button>
        </span>
        <span class='mr15'>
          <a-button @click='delMenus'>
            <DeleteOutlined /> 批量删除
          </a-button>
        </span>
      </div>
      <a-layout>
        <a-row style="background-color:#fff;">
          <a-col :span="10">
            <a-alert message="该数据开发人员为系统生成的数据,无特殊情况请勿操作" type="warning" show-icon class='mb10' />
            <a-alert :message="'当前选择编辑：'+(selectedNodes.title?selectedNodes.title:'')" type="info" show-icon class='mb10' />
            <a-input-search class='mb10' placeholder="输入菜单名搜索" @search="onSearch" />
            <a-card title="" style="height:600px;margin-top:10px;overflow-Y:auto">
              <a-tree checkable :tree-data="treeData" 
              :replaceFields="replaceFields"
              v-model:expandedKeys="expandedKeys" v-model:selectedKeys="selectedKeys" v-model:checkedKeys="checkedKeys"
               @select="onSelect" @check="onCheck">
                <!-- <template v-slot:title><span style="color: #1890ff">sss</span></template> -->
              </a-tree>
            </a-card>
          </a-col>
          <a-col offset='1' :span="10">
            <a-card title="" style="min-height:690px">
              <myform :key='1'  :selectedNodes='selectedNodes' v-on:submit='onSubmit' />
            </a-card>
          </a-col>
        </a-row>
      </a-layout>
    </a-card>
  </a-layout>
  <a-modal v-model:visible="visible" title="新增菜单" :footer='null'  :loading="loading">
    <myform v-on:submit='onSubmit' :key='2' />
  </a-modal>
</template>
<script>
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { inject, onMounted, reactive, ref, toRefs } from "vue";
import myform from "./components/form.vue";
import { setPageState, getPageState } from "@/utils/pageState";
import { getMenu,editMenu,createMenu,delMenu } from "@/api/system";
import { $iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defForm = {
  title: "",
  hidden: false,
  type: "",
  key: "",
  icon: "",
  sort: null,
  component: "",
};
export default {
  components: { DeleteOutlined, PlusOutlined, myform },
  setup(props) {
    const form = ref({ ...defForm });
    const state = reactive({
      labelCol: { span: 4 },
      wrapperCol: { span: 12 },
      value: [],
      expandedKeys: [],
      selectedKeys: [],
      checkedKeys: [],
      visible: false,
      selectedNodes: {}, //点中的树形结构
      pid:0,
      loading:false,
      replaceFields: {
        children:'children', title:'title', key:'id'
      }
    });
    // 去出注入的工具
    const _lodash = inject("_lodash");
    const $message =inject('$message')
    const $Modal=inject('$Modal')
    // 获取菜单列表
     const treeData = ref([]);
     const getMenuData = async () => {
      const res = await getMenu()
          .then((res) => res)
          .catch((error) => error);
          treeData.value= []
          let respData = res.data || {}
          if (respData.code != 1) {
            return
          }
          let respList = respData.data || [];
          addUrlAttr(respList)
          treeData.value = respList
     }
     // 为菜单加url，因为key和a-tree组件冲突了
     const addUrlAttr = (data) => {
      if (!data || !data.length) {
        return
      }
      data.forEach((item) => {
        item.url = item.key || ''
        if (item.children && item.children.length) {
          addUrlAttr(item.children)
        }
      })
     }
    const getTree = () => {
      onMounted(async () => {
        getMenuData()
      });
      return { treeData };
    };
    // 选中树形结构处理函数
    const onSelect = function (selectedKeys, { selected,selectedNodes }) {
      if (selected) {
        let data = JSON.parse(JSON.stringify(selectedNodes[0]["props"]))
        // key被重置为id了，要返回回来
        data.key = data.url
        state.selectedNodes = data;
      } else {
        state.selectedNodes = [];
      }
    };
   // 修改弹窗 状态
    const visibleChange=(bool)=>{state.visible=bool}
    // 修改PID标识
    const pidChange=(num)=>{state.pid=num}
    // 添加子菜单
    const createSon=()=>{
        if(!_lodash.isEmpty(state.selectedNodes)){
          pidChange(state.selectedNodes.id)
          visibleChange(true)
      }else{
        $iscode({code:0,msg:"请选择上级菜单"},true)
      }
    }

    // 添加顶级菜单
    const createTop=()=>{
       pidChange(0)
       visibleChange(true)
    }
    // 定义一个id 集合 用于批量删除
    const  delId=ref()
    const onCheck=(checkedKeys,{checked,node,checkedNodes})=>{
      // lodash 方法 详情查官网
      delId.value=_lodash.map(_lodash.map(checkedNodes,"props"),'id').join(',')
    }
    // 删除菜单
    const delMenus=()=>{
      if(!delId.value){
        $message.error('请勾选需要删除的菜单')
        return
      }
        $Modal.confirm({ content: '确认删除所选菜单',
          centered:true,onOk:()=>{
          delMenu(delId.value).then(res=>{
            if($iscode(res.data,true)){
                state.checkedKeys=[]
                state.selectedNodes=[]
                getMenuData()
            }
          })
        }})
    }
    // 提交数据
    const onSubmit = function (result) {
      if(result.id){
        editMenu(result.id,result).then(res=>{
         if ($iscode(res.data,true)) {
            getMenuData()
          } else {
            state.loading=true
          }
        })
      }else{
       state.loading=true
       createMenu({...result,pid:state.pid}).then(res=>{
       if ($iscode(res.data,true)) {
            visibleChange(false)
            getMenuData()
          } else {
            state.loading=true
          }
       }).catch((error)=>{})
      }
    };
    return {
      form,
      ...toRefs(state),
      ...getTree(),
      onSelect,
      onSubmit,
      createSon,
      createTop,
      delMenus,
      onCheck
    };
  },
};
</script>